"use client";

import { Layout } from 'antd';
import styles from './WhyWe.module.scss';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { useTranslations } from 'next-intl';

const { Content } = Layout;

const whyWeData = [
  {
    id: 1,
    title: 'fastProccessing',
    desc: 'fastProccessingDesc',
  },
  {
    id: 2,
    title: 'privacy',
    desc: 'privacyDesc',
  },
  {
    id: 3,
    title: 'quality',
    desc: 'qualityDesc',
  },
  {
    id: 4,
    title: 'unlimited',
    desc: 'unlimitedDesc',
  },
];

export const WhyWe = () => {
  const t = useTranslations('textRemover.whyWe');

  return (
    <Content className={styles.root}>
      <ScrollReveal className={styles.root_title}>
        <h1>{t('title')}</h1>
      </ScrollReveal>

      <ScrollReveal className={styles.root_items}>
        {whyWeData.map((item) => (
          <section key={item.id} className={styles.root_items_item}>
            <h2>{t(item.title)}</h2>
            <p>{t(item.desc)}</p>
          </section>
        ))}
      </ScrollReveal>
    </Content>
  );
};
